<!--
	Footer.svelte
-->

<script>

    import { push } from "svelte-spa-router";

</script>

<style>
    .app-footer {
        user-select: none;
        z-index: 900;
        width: 90%;
        padding: 5px 5%;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: var(--tcare-white);
        background-color: var(--tcare-purple);
    }

    .app-footer .copyright {
        cursor: pointer;
        width: 50%;
    }

    /*
    .app-footer .copyright:hover {
        color: var(--tcare-secondary);
    }
    */

    .app-footer .right-side {
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .app-footer .right-side div {
        cursor: pointer;
        margin-left: 10px;
    }

    .app-footer .right-side div:hover {
        /* font-weight: bold; */
        color: var(--tcare-secondary);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="app-footer fixed-bottom flex-row">
    <div class="copyright" >
        &copy; 2022 TCARE Inc. All Rights Reserved
    </div>
    <div class="right-side">
        <div class="about" on:click={() => window.open('http://www.tcare.ai/about', "_blank")}>About TCARE</div>
        <div class="terms" on:click={() => push('/terms')}>Terms</div>
        <div class="privacy" on:click={() => window.open('http://www.tcare.ai/content/privacy', "_blank")}>Privacy</div>
    </div>
</div>
